
<div class="bookmark-icon" (click)="toggleBookmark(); $event.stopPropagation()" [title]="tooltip">
    <span [ngClass]="{'filled' : isBookmarked}" class="material-symbols-rounded">star</span>
    <!-- <span [ngClass]="{'filled' : isBookmarked}" class="material-symbols-rounded">favorite</span> -->
</div>
